import { render, staticRenderFns } from "./waitInspect.vue?vue&type=template&id=fec4df32&scoped=true&"
import script from "./waitInspect.vue?vue&type=script&lang=js&"
export * from "./waitInspect.vue?vue&type=script&lang=js&"
import style0 from "./waitInspect.vue?vue&type=style&index=0&id=fec4df32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec4df32",
  null
  
)

export default component.exports